// Banner.tsx — prominent flag banners. Variant maps directly to the flag's honesty tier:
// warning = feature visibly disabled; info = documented approximation / range clamp.
import type { ComponentChildren } from 'preact';

export type BannerVariant = 'warning' | 'error' | 'info' | 'neutral';

export interface BannerProps {
  variant: BannerVariant;
  title: string;
  children?: ComponentChildren;
}

export function Banner({ variant, title, children }: BannerProps) {
  const isAlert = variant === 'warning' || variant === 'error';
  return (
    <div class={`banner banner-${variant}`} role={isAlert ? 'alert' : 'status'}>
      <strong>{title}</strong>
      {children}
    </div>
  );
}
